import { Component, Input } from '@angular/core'
import { DatePipe } from '@angular/common'
import { RefundCard } from '../../models'
import { NegativeCurrencyPipe } from '../../pipes/negative-currency.pipe'

@Component({
    selector: 'ach-refund-info',
    standalone: true,
    imports: [DatePipe, NegativeCurrencyPipe],
    templateUrl: './refund-info.component.html',
    styleUrl: './refund-info.component.scss',
})
/** @deprecated Removed by US-2.20 — dynamic section collapsed to NOC only. Kept for possible revert. */
export class RefundInfoComponent {
    @Input({ required: true }) refundInfo: RefundCard[] = []

    get sortedRefunds(): RefundCard[] {
        return [...this.refundInfo].sort((a, b) =>
            new Date(b.refundDate).getTime() - new Date(a.refundDate).getTime()
        )
    }
}
